import Vue from "vue";
import VuePapaParse from 'vue-papa-parse'
import PapaParse from 'papaparse'
Vue.use(VuePapaParse)
// Vue.use(PapaParse)

Vue.prototype.$ppp = PapaParse;